export default __webpack_public_path__ + "media/images/SOC_CI-H-ISO90001-RGB-f2a491ab3b8354f96aacef7f0a67a0cc.png";